import React, { useState, useRef, useEffect } from "react";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styled from "styled-components";

import Markdown from "../../styles/Markdown";
import {
  CustomRightArrow,
  CustomLeftArrow,
  CarouselArrows,
} from "../Carousel/CarouselArrows";

const StyledListItem = styled.li`
  text-align: center;
  font-size: ${(props) => (props.isActive ? "1.3rem" : "1.125rem")};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  color: ${(props) => (props.isActive ? "#0d6efd" : "#6c757d")};

  &:hover {
    color: #0b5ed7;
  }
`;

const ImageWrapper = styled.div`
  height: ${(props) => props.imageHeight || "450px"};
  border-radius: 0.375rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

function InteractiveGallery({
  headertext,
  items,
  imageHeight,
  customLeftArrowContent,
  customRightArrowContent,
  arrowSize = 24,
  arrowColor = "#fff",
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselRef = useRef(null);

  useEffect(() => {
    if (carouselRef.current) {
      if (carouselRef.current.state.currentSlide !== activeIndex) {
        carouselRef.current.goToSlide(activeIndex);
      }
    }
  }, [activeIndex]);

  const handleItemClick = (index) => {
    setActiveIndex(index);
  };

  const responsive = {
    all: {
      breakpoint: { max: 4000, min: 0 },
      items: 1,
    },
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="container py-5">
      <div className="row g-5 align-items-center">
        <div className="col-lg-6">
          <div className="perks-header">
            <Markdown>{headertext}</Markdown>
          </div>
          <ul className="list-unstyled md-mt-5 space-y-4">
            {items.map((item, index) => (
              <StyledListItem
                key={item.id}
                isActive={activeIndex === index}
                onClick={() => handleItemClick(index)}
                className={activeIndex === index ? "is-active" : ""}
              >
                <Markdown>{item.label}</Markdown>
              </StyledListItem>
            ))}
          </ul>
        </div>

        <div className="col-lg-6">
          <Carousel
            ref={carouselRef}
            responsive={responsive}
            infinite={false}
            draggable={false}
            swipeable={false}
            containerClass="carousel-container"
            arrows={false}
            renderButtonGroupOutside
            customRightArrow={
              <CustomRightArrow arrowSize={arrowSize} arrowColor={arrowColor} />
            }
            customLeftArrow={
              <CustomLeftArrow arrowSize={arrowSize} arrowColor={arrowColor} />
            }
            afterChange={(previousSlide, { currentSlide }) => {
              // Use the modulo operator to get the real index
              const realIndex = currentSlide % items.length;
              setActiveIndex(realIndex);
            }}
            customButtonGroup={
              <CarouselArrows
                leftArrowContent={customLeftArrowContent}
                rightArrowContent={customRightArrowContent}
              />
            }
          >
            {items?.map((item) => (
              <ImageWrapper key={item?.image?.url} imageHeight={imageHeight}>
                <img
                  alt={item?.image?.alternativeText || "Perks image"}
                  src={item?.image?.url}
                  onError={(e) => {
                    console.error("Image failed to load:", item?.image?.url);
                    e.target.style.backgroundColor = "#f0f0f0";
                  }}
                />
              </ImageWrapper>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
}

export default InteractiveGallery;
